var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgcompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.9951,
    r: 9.5,
    stroke: "#00C48C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 10 10.9951)",
    fill: "#00C48C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 11.1201L9.64119 12.9951L13.3335 8.99512",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgcompleted);
export default __webpack_public_path__ + "static/media/imgcompleted.f912b05b0cf72f4a8084711d62c2fabe.svg";
export { ForwardRef as ReactComponent };